import React, { useState, useEffect } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  CardHeader,
  CardFooter,
  Col,
} from "reactstrap";
import Accordion from "react-bootstrap/Accordion";
import { useHistory, Link } from "react-router-dom";
import { Colxx } from "../../../components/common/CustomBootstrap";
import Pagination from "../../../containers/pages/Pagination";
import Select from "react-select";
import { JobService } from "../../../services/JobService";
import { showAccountsService } from "../../../services/AccountService";
import {
  fetchData,
  getEnumLists,
  getEnumLists as MetaJobEnums,
  getPosts,
  loadPost,
} from "../../../services/MetadataService";
import { ENV, isNullOrEmpty } from "../../../config/ENV";
import { BiLink } from "react-icons/bi";
import Switch from "react-switch";
import "../../../assets/css/requestsstyles.css";
import SvgUpArrow from "../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../components/svg/downarrow";
import Linkify from "react-linkify";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import defaultpostingimg from "../../../../src/assets/img/jobboard/TA-90px.gif";
const Requests = () => {
  const history = useHistory();
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");
  const [jobs, setJobs] = useState([]);
  const [accountId, setAccountId] = useState([]);
  const [accountIds, setAccountIds] = useState([]);
  const [jobStatusOptions, setJobStatusOptions] = useState([]);
  const [size, setSize] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("sortingStatus");
  const [talentAdvisor, setTalentAdvisor] = useState([]);
  const [taId, setTAId] = useState([]);
  const [taIds, setTAIds] = useState([]);
  const [jobReqStatus, setJobReqStatus] = useState([]);
  const [jobReqStatuses, setJobReqStatuses] = useState([]);
  const [priorityOption, setPriorityOption] = useState([]);
  const [priority, setPriority] = useState([]);
  const [priorities, setPriorities] = useState([]);
  const [changeTA, setChangeTA] = useState(false);
  const [changeAccount, setChangeAccount] = useState(false);
  const [changeStatus, setChangeStatus] = useState(false);
  const [changePriority, setChangePriority] = useState(false);
  const [clearSearch, setClearSearch] = useState(false);
  const [clearItems, setClearItems] = useState(false);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [title, setTitle] = useState(false);
  const [taAdvisorsList, setTaAdvisors] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [searchObj, setSearchObj] = useState({
    taIds: [],
    statuses: [],
    accountIds: [],
    priorityType: [],
    clearTa: false,
    clearAccount: false,
    clearJobStatus: false,
    clearPriority: false,
    jobTitle: "",
    itemsPerPage: "",
  });

  const [isSortBySelected, setIsSortBySelected] = useState(false);
  const [citySearch, setCitySearch] = useState("");
  const [clearCitySearch, setClearCitySearch] = useState(false);
  const [stateSearch, setStateSearch] = useState("");
  const [clearStateSearch, setClearStateSearch] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const [jobId, setJobId] = useState();
  const [count, setCount] = useState(0);

  const navigateTo = () => {
    window.localStorage.setItem("requestId", "");
    window.localStorage.setItem("add", "add");
    window.localStorage.setItem("currentStatus", "DRAFT");
    window.localStorage.setItem("candidates", "");
    history.push("/addrequest/0?t=basicinfo");
  };

  const sortByJobs = (col) => {
    setIsSortBySelected(true);
    setSortBy(col);
    sortedOrder(col, true);
  };

  const sortedOrder = (col, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }
    getAllJobs(select, col, currentPage, isSortBySelected);
  };

  const getJobEnums = () => {
    getEnumLists().then((response) => {
      if (response !== null) {
        let jobStatues = response.jobStatues;
        if (jobStatues != null) {
          filterStatus(jobStatues);
        }

        let priorities = response.priorities;
        if (priorities != null) {
          filterPriorities(priorities);
        }
      }
    });
  };

  const getAllAccounts = () => {
    showAccountsService(search).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data !== null) {
            filterAccounts(response.data.accounts);
          }
        }
      } catch (err) {}
    });
  };
  const handleLinkify = (event) => {
    event.preventDefault();
    window.open(event.target.href, "_blank");
  };
  const getTalentAdvisors = () => {
    JobService.getTAService(search).then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data !== null) {
            filterTAs(response.data.members);
            setTaAdvisors(response.data.members);
          }
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };

  const filterAccounts = (accountList) => {
    setSearchObj((prevState) => ({
      ...prevState,
      accountIds: [],
    }));
    setAccountId([]);

    var searchValue;
    if (sessionStorage.getItem("searchobject") !== null) {
      searchValue = JSON.parse(sessionStorage.getItem("searchobject"));
    }

    if (accountList.length > 0) {
      var account = [];
      var obj = [];
      accountList.forEach((accountval, i) => {
        account.push({
          label: `${accountval.name}`,
          value: `${accountval.id}`,
        });
        setSelectedAccounts(account);
      });

      if (sessionStorage.getItem("searchobject") !== null) {
        if (!searchValue.clearAccount) {
          setAccountId(obj);
        }
      } else {
        setAccountId(obj);
      }
    }

    if (!isNullOrEmpty(sessionStorage.getItem("searchobject"))) {
      if (searchValue.accountIds !== null) {
        if (searchValue.accountIds.length > 0) {
          searchValue.accountIds.forEach((accountIdVal) => {
            accountId.push(accountIdVal);
          });
          setAccountId(accountId);
        } else if (searchValue.clearAccount) {
          setAccountId([]);
        }
      }
    }
  };

  const filterStatus = (statusList) => {
    setSearchObj((prevState) => ({
      ...prevState,
      statuses: [],
    }));
    setJobReqStatus([]);

    if (statusList.length > 0) {
      var status = [];
      statusList.forEach((statusValue, i) => {
        status.push({
          label: `${statusValue.value}`,
          value: `${statusValue.key}`,
        });
        setJobStatusOptions(status);
      });
    }

    if (!isNullOrEmpty(sessionStorage.getItem("searchobject"))) {
      var searchValue = JSON.parse(sessionStorage.getItem("searchobject"));

      if (searchValue.statuses !== null) {
        if (searchValue.statuses.length > 0) {
          searchValue.statuses.forEach((jobStatus) => {
            jobReqStatus.push(jobStatus);
          });
          setJobReqStatus(jobReqStatus);
        } else if (searchValue.clearJobStatus) {
          setJobReqStatus([]);
        }
      }
    }
  };

  const filterPriorities = (prioritiesList) => {
    setSearchObj((prevState) => ({
      ...prevState,
      priorityType: [],
    }));
    setPriority([]);

    if (prioritiesList.length > 0) {
      var priorities = [];
      prioritiesList.forEach((prioritiesValue, i) => {
        priorities.push({
          label: `${prioritiesValue.value}`,
          value: `${prioritiesValue.key}`,
        });
        setPriorityOption(priorities);
      });
    }

    if (!isNullOrEmpty(sessionStorage.getItem("searchobject"))) {
      var searchValue = JSON.parse(sessionStorage.getItem("searchobject"));

      if (searchValue.priorityType !== null) {
        if (searchValue.priorityType.length > 0) {
          searchValue.priorityType.forEach((priorityValue) => {
            priority.push(priorityValue);
          });
          setPriority(priority);
        } else if (searchValue.clearPriority) {
          setPriority([]);
        }
      }
    }
  };
  const displayingTANames = (taAdvisor) => {
    let title = "";
    if (taAdvisorsList.length > 0) {
      taAdvisorsList.map((taNames, i) => {
        if (taNames.id === taAdvisor.id) {
          let taFirstName = taNames.firstName;
          let taLastName = taNames.lastName;
          if (!isNullOrEmpty(taLastName)) {
            title = taFirstName + " " + taLastName;
          } else {
            title = taFirstName;
          }
        }
      });
    }
    return title;
  };

  const filterTAs = (taList) => {
    setSearchObj((prevState) => ({
      ...prevState,
      taIds: [],
    }));
    setTAId([]);
    if (taList.length > 0) {
      var ta = [];
      var obj = [];
      taList.forEach((tas, i) => {
        if (window.localStorage.getItem("user") !== tas.id) {
          if (!isNullOrEmpty(tas.displayName)) {
            ta.push({ label: `${tas.displayName}`, value: `${tas.id}` });
            setTalentAdvisor(ta);
          }
        } else {
          if (!isNullOrEmpty(tas.displayName)) {
            obj.push({ label: `${tas.displayName}`, value: `${tas.id}` });
            ta.push({ label: `${tas.displayName}`, value: `${tas.id}` });
            setTalentAdvisor(ta);
          }
        }
      });
    }

    if (!isNullOrEmpty(sessionStorage.getItem("searchobject"))) {
      var searchValue = JSON.parse(sessionStorage.getItem("searchobject"));
      if (searchValue.taIds !== null) {
        if (searchValue.taIds.length > 0) {
          searchValue.taIds.forEach((taIdval) => {
            taId.push(taIdval);
          });
          setTAId(taId);
        } else if (searchValue.clearTa) {
          setTAId([]);
        }
      }
    }
  };

  const getAllJobs = (sortOrder, sortBy, currentpage, isSortBySelected) => {
    var searchText = "";
    var searchItemsPerPage = "";
    var searchItemsPerPageValue = "";

    var citySearchText = "";
    var stateSearchText = "";

    setCurrentPage(currentpage);

    setTAIds([]);
    setAccountIds([]);
    setJobReqStatuses([]);
    setPriorities([]);

    setSearchObj((prevState) => ({
      ...prevState,
      taIds: [],
      accountIds: [],
      statuses: [],
      priorityType: [],
    }));

    if (clearSearch) {
      searchObj["jobTitle"] = "";
      sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
    }

    if (clearCitySearch) {
      searchObj["city"] = "";
      sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
    }

    if (clearStateSearch) {
      searchObj["state"] = "";
      sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
    }

    if (changeTA) {
      searchObj["clearTa"] = true;
      searchObj["taIds"] = [];
      sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
    }

    if (changeAccount) {
      searchObj["clearAccount"] = true;
      searchObj["accountIds"] = [];
      sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
    }

    if (changeStatus) {
      searchObj["clearJobStatus"] = true;
      searchObj["statuses"] = [];
      sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
    }

    if (changePriority) {
      searchObj["clearPriority"] = true;
      searchObj["priorityType"] = [];
      sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
    }

    if (sessionStorage.getItem("searchobject") !== null) {
      var searchValue = JSON.parse(sessionStorage.getItem("searchobject"));

      if (!isNullOrEmpty(search)) {
        searchText = search;
        searchObj["jobTitle"] = search;
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (!isNullOrEmpty(searchValue.jobTitle)) {
        searchText = searchValue.jobTitle;
        setSearch(searchValue.jobTitle);
      } else {
        searchText = "";
      }

      if (!isNullOrEmpty(citySearch)) {
        citySearchText = citySearch;
        searchObj["city"] = citySearch;
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (!isNullOrEmpty(searchValue.city)) {
        citySearchText = searchValue.city;
        setCitySearch(searchValue.city);
      } else {
        citySearchText = "";
      }

      if (!isNullOrEmpty(stateSearch)) {
        stateSearchText = stateSearch;
        searchObj["state"] = stateSearch;
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (!isNullOrEmpty(searchValue.state)) {
        stateSearchText = searchValue.state;
        setStateSearch(searchValue.state);
      } else {
        stateSearchText = "";
      }

      if (taId.length > 0) {
        searchObj["taIds"] = [];
        setTAIds([]);
        taId.forEach((taId, index) => {
          const id = taId.value;
          searchObj["taIds"].push(taId);

          if (taIds.length > 0) {
            const isFound = taIds.some((element) => {
              if (element === taId.value) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              taIds.push(id);
            }
          } else {
            taIds.push(id);
          }
        });
        setTAIds(taIds);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (searchValue.taIds.length > 0) {
        for (let j = 0; j < searchValue.taIds.length; j++) {
          if (taIds.length > 0) {
            const isFound = taIds.some((element) => {
              if (element === searchValue.taIds[j].value) {
                return true;
              }
              return false;
            });

            if (!isFound) {
              taIds.push(searchValue.taIds[j].value);
              setTAIds(taIds);
            }
          } else {
            taIds.push(searchValue.taIds[j].value);
            setTAIds(taIds);
          }
        }
      } else {
        setTAIds([]);
        setTAId([]);
      }

      if (accountId.length > 0) {
        searchObj["clearAccount"] = true;
        searchObj["accountIds"] = [];
        accountId.forEach((acId, index) => {
          const id = acId.value;
          searchObj["accountIds"].push(acId);
          if (accountIds.length > 0) {
            const isFound = accountIds.some((element) => {
              if (element === acId.value) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              accountIds.push(id);
            }
          } else {
            accountIds.push(id);
          }
        });
        setAccountIds(accountIds);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (searchValue.accountIds.length > 0) {
        for (let j = 0; j < searchValue.accountIds.length; j++) {
          if (accountIds.length > 0) {
            const isFound = accountIds.some((element) => {
              if (element === searchValue.accountIds[j].value) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              accountIds.push(searchValue.accountIds[j].value);
              setAccountIds(accountIds);
            }
          } else {
            accountIds.push(searchValue.accountIds[j].value);
            setAccountIds(accountIds);
          }
        }
      } else {
        setAccountIds([]);
        setAccountId([]);
      }

      if (jobReqStatus.length > 0) {
        searchObj["statuses"] = [];
        jobReqStatus.forEach((jobReqStatus, index) => {
          const id = jobReqStatus.value;
          searchObj["statuses"].push(jobReqStatus);
          if (jobReqStatuses.length > 0) {
            const isFound = jobReqStatuses.some((element) => {
              if (element === jobReqStatus.value) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              jobReqStatuses.push(id);
            }
          } else {
            jobReqStatuses.push(id);
          }
        });
        setJobReqStatuses(jobReqStatuses);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (searchValue.statuses.length > 0) {
        for (let j = 0; j < searchValue.statuses.length; j++) {
          if (jobReqStatuses.length > 0) {
            const isFound = jobReqStatuses.some((element) => {
              if (element === searchValue.statuses[j].value) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              jobReqStatuses.push(searchValue.statuses[j].value);
              setJobReqStatuses(jobReqStatuses);
            }
          } else {
            jobReqStatuses.push(searchValue.statuses[j].value);
            setJobReqStatuses(jobReqStatuses);
          }
        }
      } else {
        setJobReqStatuses([]);
        setJobReqStatus([]);
      }

      if (priority.length > 0) {
        searchObj["priorityType"] = [];
        priority.forEach((priorityValue, index) => {
          const id = priorityValue.value;
          searchObj["priorityType"].push(priorityValue);
          if (priorities.length > 0) {
            const isFound = priorities.some((element) => {
              if (element === priorityValue.value) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              priorities.push(id);
            }
          } else {
            priorities.push(id);
          }
        });
        setPriorities(priorities);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (searchValue.priorityType.length > 0) {
        for (let j = 0; j < searchValue.priorityType.length; j++) {
          if (priorities.length > 0) {
            const isFound = priorities.some((element) => {
              if (element === searchValue.priorityType[j].value) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              priorities.push(searchValue.priorityType[j].value);
              setPriorities(priorities);
            }
          } else {
            priorities.push(searchValue.priorityType[j].value);
            setPriorities(priorities);
          }
        }
      } else {
        setPriorities([]);
        setPriority([]);
      }
    } else {
      if (!isNullOrEmpty(search)) {
        searchText = search;
        searchObj["jobTitle"] = search;
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (clearSearch) {
        searchText = "";
      } else {
        searchText = "";
      }

      if (!isNullOrEmpty(citySearch)) {
        citySearchText = citySearch;
        searchObj["city"] = citySearch;
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (clearSearch) {
        citySearchText = "";
      } else {
        citySearchText = "";
      }

      if (!isNullOrEmpty(stateSearch)) {
        stateSearchText = stateSearch;
        searchObj["state"] = stateSearch;
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (stateSearch) {
        stateSearchText = "";
      } else {
        stateSearchText = "";
      }

      if (taId.length > 0) {
        taId.forEach((taIdItem, index) => {
          const id = taIdItem.value;
          searchObj["taIds"].push(taIdItem);
          const isFound = taIds.some((element) => {
            if (element === id) {
              return true;
            }
            return false;
          });

          if (!isFound) {
            taIds.push(id);
          }
        });
        setTAIds(taIds);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (changeTA === true) {
        setTAIds([]);
      } else {
        if (!isNullOrEmpty(window.localStorage.getItem("user"))) {
          if (taIds.length > 0) {
            const isFound = taIds.some((element) => {
              if (element === window.localStorage.getItem("user")) {
                return true;
              }
              return false;
            });
            if (!isFound) {
              //    taIds.push(window.localStorage.getItem("user"));
              setTAIds(taIds);
            }
          } else {
            if (sessionStorage.getItem("searchobject") !== null) {
              let searchValue = JSON.parse(
                sessionStorage.getItem("searchobject")
              );
              if (searchValue.clearTa) {
                setTAIds([]);
              } else {
                setTAIds(taIds);
              }
            } else {
              setTAIds(taIds);
            }
          }
        } else {
          setTAIds([]);
        }
      }

      if (accountId.length > 0) {
        accountId.forEach((acId, index) => {
          const id = acId.value;
          searchObj["accountIds"].push(acId);
          const isFound = accountIds.some((element) => {
            if (element === id) {
              return true;
            }
            return false;
          });

          if (!isFound) {
            accountIds.push(id);
          }
        });
        setAccountIds(accountIds);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (changeAccount === true) {
        setAccountIds([]);
      } else {
        setAccountIds([]);
      }

      if (jobReqStatus.length > 0) {
        jobReqStatus.forEach((reqStatus, index) => {
          const id = reqStatus.value;
          searchObj["statuses"].push(reqStatus);
          const isFound = jobReqStatuses.some((element) => {
            if (element === id) {
              return true;
            }
            return false;
          });
          if (!isFound) {
            jobReqStatuses.push(id);
          }
        });
        setJobReqStatuses(jobReqStatuses);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (changeStatus === true) {
        setJobReqStatuses([]);
      } else {
        setJobReqStatuses([]);
      }

      if (priority.length > 0) {
        priority.forEach((priorityValue, index) => {
          const id = priorityValue.value;
          searchObj["priorityType"].push(priorityValue);
          const isFound = priorities.some((element) => {
            if (element === id) {
              return true;
            }
            return false;
          });
          if (!isFound) {
            priorities.push(id);
          }
        });
        setPriorities(priorities);
        sessionStorage.setItem("searchobject", JSON.stringify(searchObj));
      } else if (changePriority === true) {
        setPriorities([]);
      } else {
        setPriorities([]);
      }
    }

    if (sessionStorage.getItem("searchItems") !== null) {
      const searchItems = sessionStorage.getItem("searchItems");
      if (itemsPerPage !== undefined) {
        if (itemsPerPage !== "") {
          sessionStorage.setItem("searchItems", itemsPerPage);
          searchItemsPerPage = itemsPerPage;
        } else {
          searchItemsPerPage = "";
          sessionStorage.setItem("searchItems", "");
        }
      } else if (searchItems !== "") {
        setItemsPerPage(searchItems);
        searchItemsPerPage = searchItems;
      } else {
        searchItemsPerPage = "";
        sessionStorage.setItem("searchItems", "");
      }
    } else {
      if (itemsPerPage === undefined || itemsPerPage === "") {
        sessionStorage.setItem("searchItems", "");
        searchItemsPerPage = "";
      } else if (clearItems) {
        searchItemsPerPage = "";
        sessionStorage.setItem("searchItems", "");
      } else {
        sessionStorage.setItem("searchItems", itemsPerPage);
        searchItemsPerPage = itemsPerPage;
      }
    }

    if (searchItemsPerPage === undefined || searchItemsPerPage === "") {
      searchItemsPerPageValue = 25;
    } else {
      searchItemsPerPageValue = searchItemsPerPage;
    }

    if (sessionStorage.getItem("sortBy") !== null) {
      const sortByValue = sessionStorage.getItem("sortBy");
      if (!isNullOrEmpty(sortByValue)) {
        if (!isSortBySelected) {
          sortBy = sortByValue;
          setSortBy(sortBy);
        } else {
          sessionStorage.setItem("sortBy", sortBy);
        }
      } else {
        sessionStorage.setItem("sortBy", sortBy);
      }
    } else {
      sessionStorage.setItem("sortBy", sortBy);
    }

    if (sessionStorage.getItem("sortOrder") !== null) {
      const sortOrderValue = sessionStorage.getItem("sortOrder");
      if (!isNullOrEmpty(sortOrderValue)) {
        if (!isSortBySelected) {
          sortOrder = sortOrderValue;
          setSortOrder(sortOrder);
        } else {
          sessionStorage.setItem("sortOrder", sortOrder);
        }
      } else {
        sessionStorage.setItem("sortOrder", sortOrder);
      }
    } else {
      sessionStorage.setItem("sortOrder", sortOrder);
    }
    JobService.getJobs(
      searchText,
      jobReqStatuses,
      priorities,
      accountIds,
      taIds,
      citySearchText,
      stateSearchText,
      searchItemsPerPageValue,
      currentPage,
      sortBy,
      sortOrder
    ).then((response) => {
      try {
        if (response.data != null) {
          let size = response.data.size;
          setSize(size);
          setJobs(response.data.jobs);
          const pages = Math.floor(size / searchItemsPerPageValue);
          if (Math.round(size % searchItemsPerPageValue) > 0) {
            const totalPages = pages + 1;
            setTotalPage(totalPages);
          } else {
            const totalPages = pages;
            setTotalPage(totalPages);
          }
        }
      } catch (err) {
        console.log("JobService" + JSON.stringify(err.message));
      }
    });
  };

  useEffect(() => {
    if (sessionStorage.getItem("jobTitle") != null) {
      let isTitle = sessionStorage.getItem("jobTitle");
      if (isTitle == "true") {
        setTitle(true);
      } else {
        setTitle(false);
      }
    } else {
      sessionStorage.setItem("jobTitle", title);
    }
    setTAId([]);
    setTAIds([]);
    getJobEnums();
    getAllAccounts();
    getTalentAdvisors();
  }, []);

  useEffect(() => {
    getAllJobs(sortOrder, sortBy, currentPage, isSortBySelected);
  }, [itemsPerPage, currentPage]);

  function handleAccountChange(e) {
    setAccountIds([]);
    setAccountId([]);

    if (e.length === 0) {
      setAccountIds([]);
      setChangeAccount(true);
    } else {
      setAccountId(e);
      setChangeAccount(false);
    }
  }

  function handleTAChange(e) {
    setTAIds([]);
    setTAId([]);

    if (e.length === 0) {
      setTAIds([]);
      setChangeTA(true);
    } else {
      setTAId(e);
      setChangeTA(false);
    }
  }

  function handleJobStatusSelectChange(e, key) {
    setJobReqStatuses([]);
    setJobReqStatus([]);
    if (e.length === 0) {
      setJobReqStatuses([]);
      setChangeStatus(true);
    } else {
      setJobReqStatus(e);
      setChangeStatus(false);
    }
  }

  function handleSearch(e, key) {
    setSearch(e.target.value);
    if (e.target.value.length === 0) {
      setClearSearch(true);
    } else {
      setClearSearch(false);
    }
  }

  function handleCitySearch(e, key) {
    setCitySearch(e.target.value);
    if (e.target.value.length === 0) {
      setClearCitySearch(true);
    } else {
      setClearCitySearch(false);
    }
  }

  function handleStateSearch(e, key) {
    setStateSearch(e.target.value);
    if (e.target.value.length === 0) {
      setClearStateSearch(true);
    } else {
      setClearStateSearch(false);
    }
  }

  function handleItemsPerChange(e, key) {
    if (e.target.value === "") {
      setClearItems(true);
      sessionStorage.removeItem("searchItems");
    } else {
      setClearItems(false);
      setItemsPerPage(e.target.value);
    }

    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }

  function handleprioritychange(e, key) {
    setPriorities([]);
    setPriority([]);
    if (e.length === 0) {
      setPriorities([]);
      setChangePriority(true);
    } else {
      setPriority(e);
      setChangePriority(true);
    }
  }

  const copyUrl = (id) => {
    const el = document.createElement("input");
    el.value = ENV.hmsLinkUrl + "sd?p=hms&id=" + id;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    window.open(ENV.hmsLinkUrl + "sd?p=hms&id=" + id);
  };

  const getSerialNumber = (index) => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  const showHMSIcon = (status) => {
    if (status !== "DRAFT" && status !== "OPPORTUNITY") return true;
    else return false;
  };

  const copyLPUrl = (id, landingPageTemplate, landingPageFields) => {
    const el = document.createElement("input");
    var templateUrl = ENV.candidate_web_url + "?p=jobreq&jobId=" + id;
    let jobLandingPageTemplate = "";
    if (!isNullOrEmpty(landingPageTemplate)) {
      jobLandingPageTemplate = landingPageTemplate;
      templateUrl = templateUrl + "&templateName=" + jobLandingPageTemplate;
    }

    if (landingPageFields !== null) {
      let landingPageTemplateFields = landingPageFields;
      if (landingPageTemplateFields.length > 0) {
        landingPageTemplateFields.forEach((template) => {
          let name = template.name;
          let value = template.value;
          templateUrl = templateUrl + "&" + name + "=" + value;
        });
      }
    }
    el.value = encodeURI(templateUrl);
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    // window.open(templateUrl);
  };

  const showCity = (address) => {
    if (!isNullOrEmpty(address)) {
      if (!isNullOrEmpty(address.city)) {
        if (address.city.length > 10) {
          return (
            <div title={address.city}>
              {" "}
              {address.city.substring(0, 10) + "..."}
            </div>
          );
        } else {
          return address.city;
        }
      }
      return "";
    }
    return;
  };

  const showState = (address) => {
    if (!isNullOrEmpty(address)) {
      if (!isNullOrEmpty(address.state)) {
        if (address.state.length > 10) {
          return (
            <div title={address.state}>
              {" "}
              {address.state.substring(0, 10) + "..."}
            </div>
          );
        } else {
          return address.state;
        }
      }
      return "";
    }

    return;
  };

  const handleTitleSelect = () => {
    sessionStorage.setItem("jobTitle", !title);
    setTitle(!title);
  };

  const displayHmsIcon = (
    status,
    appliedStatusCandidates,
    statusUpdatedOn,
    hmsId
  ) => {
    let candidatesSelectedHireCount = getSelectedForHireCandidates(
      appliedStatusCandidates,
      status
    );

    let candidatesInterviewScheduledCount = getInterviewScheduledCandidates(
      appliedStatusCandidates,
      status
    );

    let candidatesRejectedCount = getRejectedScheduledCandidates(
      appliedStatusCandidates,
      status
    );

    let candidatesWithdrawCount = getWithDrawCandidates(
      appliedStatusCandidates,
      status
    );

    let candidatesTAShortListedCount = getTAShortListedCandidates(
      appliedStatusCandidates,
      status
    );

    let totalHmsCount =
      candidatesSelectedHireCount +
      candidatesInterviewScheduledCount +
      candidatesRejectedCount +
      candidatesWithdrawCount +
      candidatesTAShortListedCount;

    // let totalHmsCount =
    //   candidatesSelectedHireCount +
    //   candidatesInterviewScheduledCount +
    //   // candidatesRejectedCount +
    //   // candidatesWithdrawCount +
    //   candidatesTAShortListedCount;

    let totalHmsCountExceptRejectedWithDrawCount =
      candidatesSelectedHireCount +
      candidatesInterviewScheduledCount +
      candidatesTAShortListedCount;

    return (
      <div>
        {(() => {
          switch (status) {
            case "OPPORTUNITY":
              // case "DRAFT":
              return (
                <div
                  title="HMS not ready"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  className="flex text-base text-[#000000] font-semibold text-center justify-center items-center w-[48px] h-[48px] t-border t-border-[#333333]"
                >
                  N/A
                </div>
              );

            case "LOST":
              return (
                <Link
                  to={`/sd?p=hms&id=${hmsId}`}
                  title="Closed / Lost"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  onClick={(e) => copyUrl(hmsId)}
                >
                  <div className="flex flex-col text-base text-[#B50000] font-semibold text-center justify-items-center items-center w-[48px] h-[48px] t-border t-border-[#B50000]">
                    <span className="flex w-[30px] h-[28px] items-center justify-center">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.63107 10.3689L5.99994 6M10.3688 1.63113L5.99994 6M5.99994 6L1.63107 1.63113M5.99994 6L10.3688 10.3689"
                          stroke="#B50000"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="t-line-height text-[11px]">
                      {statusUpdatedOn == 0 ? (
                        <></>
                      ) : (
                        <>{showLocalDateTime(statusUpdatedOn)}</>
                      )}
                    </span>
                  </div>
                </Link>
              );

            case "CANCELLED":
              return (
                <Link
                  to={`/sd?p=hms&id=${hmsId}`}
                  title="Cancelled"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  onClick={(e) => copyUrl(hmsId)}
                >
                  <div className="flex flex-col text-base text-[#E9A82B] font-semibold text-center justify-items-center items-center w-[48px] h-[48px] t-border t-border-[#E9A82B]">
                    <span className="flex w-[30px] h-[28px] items-center justify-center">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.63107 10.3689L5.99994 6M10.3688 1.63113L5.99994 6M5.99994 6L1.63107 1.63113M5.99994 6L10.3688 10.3689"
                          stroke="#E9A82B"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="t-line-height text-[11px]">
                      {statusUpdatedOn == 0 ? (
                        <></>
                      ) : (
                        <>{showLocalDateTime(statusUpdatedOn)}</>
                      )}
                    </span>
                  </div>
                </Link>
              );

            case "FILLED":
              return (
                <Link
                  to={`/sd?p=hms&id=${hmsId}`}
                  title="Closed / Won"
                  data-toggle="modal"
                  data-target="#exampleModal"
                  onClick={(e) => copyUrl(hmsId)}
                >
                  <div className="flex flex-col text-base text-[#63BD43] font-semibold text-center justify-items-center items-center w-[48px] h-[48px] t-border t-border-[#63BD43]">
                    <span className="flex w-[30px] h-[28px] items-center justify-center">
                      <svg
                        width="16"
                        height="11"
                        viewBox="0 0 14 10"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.1665 5.83325L4.49984 9.16659L12.8332 0.833252"
                          stroke="#63BD43"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                    <span className="t-line-height text-[11px]">
                      {statusUpdatedOn == 0 ? (
                        <></>
                      ) : (
                        <>{showLocalDateTime(statusUpdatedOn)}</>
                      )}
                    </span>
                  </div>
                </Link>
              );

            case "ACTIVE":
            case "ONHOLD":
            case "HMS_SENT":
              if (totalHmsCount === 0) {
                return (
                  <div
                    title="HMS not ready"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    className="flex text-base text-[#000000] font-semibold text-center justify-center items-center w-[48px] h-[48px] t-border t-border-[#333333]"
                  >
                    N/A
                  </div>
                );
              } else if (candidatesSelectedHireCount > 0) {
                return (
                  <Link
                    to={`/sd?p=hms&id=${hmsId}`}
                    title="Job offer extended"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={(e) => copyUrl(hmsId)}
                  >
                    <div className="flex flex-col text-base text-[#63BD43] font-semibold text-center justify-items-center items-center w-[48px] h-[48px] t-border t-border-[#63BD43]">
                      <span className="leading-7 ">
                        {totalHmsCountExceptRejectedWithDrawCount}
                      </span>
                      <span className="t-line-height text-[11px]">
                        {statusUpdatedOn == 0 ? (
                          <></>
                        ) : (
                          <>{showLocalDateTime(statusUpdatedOn)}</>
                        )}
                      </span>
                    </div>
                  </Link>
                );
              } else if (candidatesInterviewScheduledCount > 0) {
                return (
                  <Link
                    to={`/sd?p=hms&id=${hmsId}`}
                    title="Interview(s) scheduled"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={(e) => copyUrl(hmsId)}
                  >
                    <div className="flex flex-col text-base text-[#E9A82B] font-semibold text-center justify-items-center items-center w-[48px] h-[48px] t-border t-border-[#E9A82B]">
                      <span className="leading-7">
                        {totalHmsCountExceptRejectedWithDrawCount}
                      </span>
                      <span className="t-line-height text-[11px]">
                        {statusUpdatedOn == 0 ? (
                          <></>
                        ) : (
                          <>{showLocalDateTime(statusUpdatedOn)}</>
                        )}
                      </span>
                    </div>
                  </Link>
                );
              } else if (candidatesTAShortListedCount > 0) {
                return (
                  <Link
                    to={`/sd?p=hms&id=${hmsId}`}
                    title="HMS under review"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={(e) => copyUrl(hmsId)}
                  >
                    <div className="flex flex-col text-base text-[#000000] font-semibold text-center justify-items-center items-center w-[48px] h-[48px] t-border t-border-[#000000]">
                      <span className="leading-7 ">
                        {totalHmsCountExceptRejectedWithDrawCount}
                      </span>
                      <span className="t-line-height text-[11px] ">
                        {statusUpdatedOn == 0 ? (
                          <></>
                        ) : (
                          <>{showLocalDateTime(statusUpdatedOn)}</>
                        )}
                      </span>
                    </div>
                  </Link>
                );
              } else if (
                candidatesRejectedCount > 0 ||
                candidatesWithdrawCount > 0
              ) {
                return (
                  <Link
                    to={`/sd?p=hms&id=${hmsId}`}
                    title="Some candidates rejected, none shortlisted"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    onClick={(e) => copyUrl(hmsId)}
                  >
                    <div className="flex flex-col text-base text-[#B50000] font-semibold text-center justify-items-center items-center w-[48px] h-[48px] t-border t-border-[#B50000]">
                      <span className="leading-7 ">&nbsp;</span>
                      <span className="t-line-height text-[11px]">
                        {statusUpdatedOn == 0 ? (
                          <></>
                        ) : (
                          <>{showLocalDateTime(statusUpdatedOn)}</>
                        )}
                      </span>
                    </div>
                  </Link>
                );
              } else {
                return (
                  <div
                    title="HMS not ready"
                    data-toggle="modal"
                    data-target="#exampleModal"
                    className="flex text-base text-[#000000] font-semibold text-center justify-center items-center w-[48px] h-[48px] t-border t-border-[#333333]"
                  >
                    N/A
                  </div>
                );
              }

            default:
              break;
          }
        })()}
      </div>
    );
  };

  const showLocalDateTime = (notecreatedOn) => {
    var date = new Date(notecreatedOn);
    var months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months[date.getMonth()] + " " + date.getDate();
  };

  const isNavigateHms = (status) => {
    if (status === "DRAFT") {
      return false;
    } else if (status === "OPPORTUNITY") {
      return false;
    } else {
      return true;
    }
  };

  const appliedJobCandidatesCount = (appliedStatusCandidates) => {
    // let candidateCount = 0;

    let candidateCount = appliedStatusCandidates;
    if (appliedStatusCandidates.length > 0) {
      appliedStatusCandidates.forEach((candidateStatus) => {
        if (candidateStatus.status !== null) {
          let currrentStatus = candidateStatus.status;
          if (currrentStatus.key !== null) {
            let statusKey = currrentStatus.key;
            if (statusKey === "APPLIED") {
              if (candidateStatus.count !== null) {
                candidateCount = candidateStatus.count;
              }
            }
          }
        }
      });
    }
    // else {
    //   candidateCount = 0;
    // }
    return candidateCount;
  };

  const appliedJobCandidatesTotalCount = (appliedStatusTotalCandidates) => {
    // let candidateCount = 0;
    let candidateCount = appliedStatusTotalCandidates;
    if (appliedStatusTotalCandidates.length > 0) {
      appliedStatusTotalCandidates.forEach((candidateStatus) => {
        let statusBasedCandidateCount = candidateStatus.count;
        candidateCount = candidateCount + statusBasedCandidateCount;
      });
    }
    // else {
    //   candidateCount = 0;
    // }
    return candidateCount;
  };
  const getWithDrawCandidates = (appliedStatusCandidates, status) => {
    let candidatesCount = 0;
    let totalWithdrawn = appliedStatusCandidates.totalWithdrawn;
    let totalWithdrawnPost = appliedStatusCandidates.totalWithdrawnPost;
    candidatesCount = totalWithdrawn + totalWithdrawnPost;
    return candidatesCount;
  };

  const getTAShortListedCandidates = (appliedStatusCandidates, status) => {
    let candidatesCount = 0;
    let totalTaShortlisted = appliedStatusCandidates.totalTaShortlisted;
    let totalShortlisted = appliedStatusCandidates.totalShortlisted;
    candidatesCount = totalTaShortlisted + totalShortlisted;
    return candidatesCount;
  };

  const getSelectedForHireCandidates = (appliedStatusCandidates, status) => {
    let candidatesCount = 0;
    let totalSelectedForHire = appliedStatusCandidates.totalSelectedForHire;
    let totalJobOfferAccepted = appliedStatusCandidates.totalJobOfferAccepted;

    if (status === "ACTIVE" || status === "ONHOLD" || status === "HMS_SENT") {
      candidatesCount = totalSelectedForHire + totalJobOfferAccepted;
    }
    return candidatesCount;
  };

  const getInterviewScheduledCandidates = (appliedStatusCandidates, status) => {
    let candidatesCount = 0;
    let totalInterviewRequested =
      appliedStatusCandidates.totalInterviewRequested;
    let totalInterviewCompleted =
      appliedStatusCandidates.totalInterviewCompleted;
    let totaInterviewScheduled = appliedStatusCandidates.totaInterviewScheduled;

    if (status === "ACTIVE" || status === "ONHOLD" || status === "HMS_SENT") {
      candidatesCount =
        totalInterviewRequested +
        totalInterviewCompleted +
        totaInterviewScheduled;
    }
    return candidatesCount;
  };

  const getRejectedScheduledCandidates = (appliedStatusCandidates, status) => {
    let candidatesCount = 0;
    let totalRejected = appliedStatusCandidates.totalRejected;
    candidatesCount = totalRejected;
    return candidatesCount;
  };

  const toggle = (id) => {
    setJobId(id);
    setIsOpened((wasOpened) => !wasOpened);
  };

  const handleMouseEnter = (id) => {
    setJobId(id);
    setShowTooltip(true);
  };
  const newFunction = () => {
    var newSortBy = "";
    var newSortOrder = "";
    var newIsSortBySelected = true;
    if (count % 4 == 0) {
      newSortOrder = "asc";
      newSortBy = "totalApplied";
    }
    if (count % 4 == 1) {
      newSortOrder = "desc";
      newSortBy = "totalApplied";
    }
    if (count % 4 == 2) {
      newSortOrder = "asc";
      newSortBy = "totalCandidates";
    }
    if (count % 4 == 3) {
      newSortOrder = "desc";
      newSortBy = "totalCandidates";
    }
    setIsSortBySelected(newIsSortBySelected);
    setSortBy(newSortBy);
    setSortOrder(newSortOrder);
    getAllJobs(newSortOrder, newSortBy, currentPage, newIsSortBySelected);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const candidateCount = () => {
    var temp = count + 1;
    setCount(temp);
    newFunction();
  };

  const displayLpUrl = (jobId, landingPageTemplate, landingPageFields) => {
    let templateUrl = ENV.candidate_web_url + "?p=jobreq&jobId=" + jobId;
    let jobLandingPageTemplate = "";
    if (!isNullOrEmpty(landingPageTemplate)) {
      jobLandingPageTemplate = landingPageTemplate;
      templateUrl = templateUrl + "&templateName=" + jobLandingPageTemplate;
    }
    if (landingPageFields !== null) {
      let landingPageTemplateFields = landingPageFields;
      if (landingPageTemplateFields.length > 0) {
        landingPageTemplateFields.forEach((template) => {
          let name = template.name;
          let value = template.value;
          templateUrl = templateUrl + "&" + name + "=" + value;
        });
      }
    }

    return (
      <>
        {(() => {
          return (
            <a
              href={`${templateUrl}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
                className="iconsminds-folder   t-cursor-pointer"
                color="primary"
                size="sm"
                outline="true"
                onClick={(e) =>
                  copyLPUrl(jobId, landingPageTemplate, landingPageFields)
                }
              >
                <path d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z" />
              </svg>
            </a>
          );
        })()}
      </>
    );
  };

  return (
    <>
      <script
        src="https://cdn.jsdelivr.net/npm/react/umd/react.production.min.js"
        crossOrigin="true"
      ></script>

      <script
        src="https://cdn.jsdelivr.net/npm/react-dom/umd/react-dom.production.min.js"
        crossOrigin="true"
      ></script>

      <script
        src="https://cdn.jsdelivr.net/npm/react-bootstrap@next/dist/react-bootstrap.min.js"
        crossOrigin="true"
      ></script>

      <script>var Alert = ReactBootstrap.Alert;</script>

      <div>
        <div>
          <Card className="mt-2 w-100 t-card-wid">
            <CardHeader>
              <div className=" ">
                <Row>
                  <Colxx xs={9}>
                    <strong>Job Requisitions</strong>
                  </Colxx>
                  <Colxx xs={3}>
                    <div
                      className="text-right "
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        outline
                        color="primary"
                        size="sm"
                        onClick={navigateTo}
                      >
                        Add
                      </Button>
                    </div>
                  </Colxx>
                </Row>
              </div>
            </CardHeader>

            <Accordion defaultActiveKey="0" className="Search-accordion">
              <div className="job-req-search-card t-card-top">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="search-accordion-header ">
                    Search
                  </Accordion.Header>

                  <Accordion.Body>
                    <div className="mb-3">
                      <Row>
                        <Colxx md={12} className="">
                          <div className="row form-group">
                            <Select
                              isMulti
                              placeholder="Select Account"
                              className="req_dropdown col-sm-12"
                              closeMenuOnSelect={false}
                              value={accountId}
                              options={selectedAccounts}
                              onChange={(e) => handleAccountChange(e)}
                            />
                          </div>
                        </Colxx>

                        <Colxx md={12} className="">
                          <div className="row form-group">
                            <Select
                              closeMenuOnSelect={false}
                              isMulti
                              placeholder="Select Assigned TA"
                              className="req_dropdown col-sm-12"
                              value={taId}
                              options={talentAdvisor}
                              onChange={(e) => handleTAChange(e)}
                            />
                          </div>
                        </Colxx>

                        {/* <Colxx md={12} className="">
                          <div className="row form-group">
                            <Select
                              closeMenuOnSelect={false}
                              isMulti
                              placeholder="Select Job Status"
                              className="req_dropdown col-sm-12"
                              onChange={(e) => handleJobStatusSelectChange(e)}
                              value={jobReqStatus}
                              options={jobStatusOptions}
                            />
                          </div>
                        </Colxx> */}

                        {/* <Colxx md={4} className="">
                          <Input
                            type=""
                            name=""
                            placeholder="Search by Job ID or Job Title or City or State"
                            onChange={handleSearch}
                            value={search}
                            className="req_dropdown t-rounded-lg "
                          ></Input>
                        </Colxx>
                        <Colxx md={4} className="">
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            placeholder="Select Priority"
                            className="req_dropdown"
                            onChange={(e) => handleprioritychange(e)}
                            value={priority}
                            options={priorityOption}
                          />
                        </Colxx>
                        <Colxx md={4} className="">
                          <Input
                            className="t-rounded-lg"
                            type="select"
                            value={itemsPerPage}
                            onChange={handleItemsPerChange}
                          >
                            <option value={''}>Items Per Page</option>
                            <option value={'10'}>10</option>
                            <option value={'25'}>25</option>
                            <option value={'50'}>50</option>
                            <option value={'100'}>100</option>
                          </Input>
                        </Colxx> */}

                        <Colxx md={9} className="">
                          <div className="row form-group">
                            <Select
                              closeMenuOnSelect={false}
                              isMulti
                              placeholder="Select Job Status"
                              className="req_dropdown col-sm-12"
                              onChange={(e) => handleJobStatusSelectChange(e)}
                              value={jobReqStatus}
                              options={jobStatusOptions}
                            />
                          </div>
                        </Colxx>

                        <Colxx md={3} className="">
                          <Select
                            closeMenuOnSelect={false}
                            isMulti
                            placeholder="Select Priority"
                            className="req_dropdown"
                            onChange={(e) => handleprioritychange(e)}
                            value={priority}
                            options={priorityOption}
                          />
                        </Colxx>

                        <Colxx md={3} className="">
                          <Input
                            type=""
                            name=""
                            placeholder="Search by Job ID or Title or Public Title "
                            onChange={handleSearch}
                            value={search}
                            className="req_dropdown t-rounded-lg "
                          ></Input>
                        </Colxx>

                        <Colxx md={3} className="">
                          <Input
                            type=""
                            name=""
                            placeholder="Search by City"
                            onChange={handleCitySearch}
                            value={citySearch}
                            className="req_dropdown t-rounded-lg "
                          ></Input>
                        </Colxx>

                        <Colxx md={3} className="">
                          <Input
                            type=""
                            name=""
                            placeholder="Search by State"
                            onChange={handleStateSearch}
                            value={stateSearch}
                            className="req_dropdown t-rounded-lg "
                          ></Input>
                        </Colxx>

                        <Colxx md={3} className="">
                          <Input
                            className="t-rounded-lg"
                            type="select"
                            value={itemsPerPage}
                            onChange={handleItemsPerChange}
                          >
                            <option value={""}>Items Per Page</option>
                            <option value={"10"}>10</option>
                            <option value={"25"}>25</option>
                            <option value={"50"}>50</option>
                            <option value={"100"}>100</option>
                          </Input>
                        </Colxx>
                        <Colxx md={10} className="">
                          <div className="row col-sm-12 col-form-label">
                            <div className="">
                              <Button
                                color="primary"
                                outline
                                size="sm"
                                onClick={(e) =>
                                  getAllJobs(
                                    sortOrder,
                                    sortBy,
                                    1,
                                    isSortBySelected
                                  )
                                }
                              >
                                Search
                              </Button>
                            </div>
                          </div>
                        </Colxx>
                      </Row>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </div>
            </Accordion>

            <hr />

            {/* <Row className="mt-1">
              <Colxx sm={9}></Colxx>
              <Colxx sm={3}>
                <div className="row">
                    {" "}
                       <AiOutlineUserAdd className="w-5 t-user"
                    />
                  <div> -  Awaiting Candidates</div>
                </div>
                <div className="row">
                <AiOutlineUsergroupAdd
                      className="w-5 t-user"
                    />
                  <div> -  Total Candidates</div>
                </div>
              </Colxx>
            </Row> */}

            <CardBody>
              <div>
                <div className="tableContainer">
                  <div className="tablewrapper">
                    <Table className="hms_table jobRequisition_table table-responsive">
                      <thead>
                        <tr>
                          <th className="w-5">S.No</th>
                          <th
                            onClick={() => sortByJobs("jobId")}
                            className="w-10"
                          >
                            <Row className="w-[100]">
                              {" "}
                              <div className="col t-cursor-pointer"> ID </div>
                              <div className="col ">
                                {sortBy == "jobId" ? (
                                  <>
                                    {sortBy === "jobId" ? (
                                      sortOrder === "asc" ? (
                                        <>
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}
                              </div>
                            </Row>
                          </th>

                          <th className="w-20 ">
                            <label
                              className="mr-2 m-0 toggle_width"
                              onClick={() => {
                                title == true
                                  ? sortByJobs("publicTitle")
                                  : sortByJobs("jobTitle");
                              }}
                            >
                              <Row>
                                {" "}
                                <div className="col pr-0 t-cursor-pointer">
                                  {" "}
                                  {title !== true ? "Title" : "Public Title"}
                                </div>
                                <div className="col">
                                  {sortBy == "jobTitle" ||
                                  sortBy === "publicTitle" ? (
                                    <>
                                      {sortBy === "jobTitle" ||
                                      sortBy === "publicTitle" ? (
                                        sortOrder === "asc" ? (
                                          <>
                                            <Row>
                                              <SvgSelectedUpArrow />
                                            </Row>
                                            <Row>
                                              <SvgDownArrow />
                                            </Row>
                                          </>
                                        ) : (
                                          <>
                                            <Row>
                                              <SvgUpArrow />
                                            </Row>
                                            <Row>
                                              {" "}
                                              <SvgSelectedDownArrow />
                                            </Row>
                                          </>
                                        )
                                      ) : (
                                        <></>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {" "}
                                      <Row>
                                        <SvgUpArrow />
                                      </Row>
                                      <Row>
                                        <SvgDownArrow />
                                      </Row>
                                    </>
                                  )}
                                </div>
                              </Row>
                            </label>
                            <label className="toggle">
                              <Switch
                                checked={title}
                                onChange={handleTitleSelect}
                                onColor="#86D3FF"
                                handleDiameter={30}
                                uncheckedIcon={false}
                                checkedIcon={false}
                                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                height={10}
                                width={40}
                                className="react-switch t-flex"
                                // id="material-switch"
                              />
                            </label>
                          </th>
                          <th
                            onClick={() => sortByJobs("sortingStatus")}
                            className="w-15"
                          >
                            <Row className="w-[100]">
                              {" "}
                              <div className="col pr-1 t-cursor-pointer">
                                {" "}
                                Status{" "}
                              </div>
                              <div className="col">
                                {sortBy == "sortingStatus" ? (
                                  <>
                                    {" "}
                                    {sortBy === "sortingStatus" ? (
                                      sortOrder === "asc" ? (
                                        <>
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}
                              </div>
                            </Row>
                          </th>
                          <th
                            onClick={() => sortByJobs("account")}
                            className="w-15"
                          >
                            <Row className="w-[100]">
                              {" "}
                              <div className="col pr-0 t-cursor-pointer">
                                Account
                              </div>
                              <div className="col">
                                {sortBy === "account" ? (
                                  <>
                                    {" "}
                                    {sortBy === "account" ? (
                                      sortOrder === "asc" ? (
                                        <>
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}
                              </div>
                            </Row>
                          </th>

                          <th
                            onClick={() => sortByJobs("city")}
                            className="w-10"
                          >
                            <Row className="w-[100]">
                              {" "}
                              <div className="col pr-1 t-cursor-pointer">
                                {" "}
                                City{" "}
                              </div>
                              <div className="col">
                                {sortBy == "city" ? (
                                  <>
                                    {sortBy === "city" ? (
                                      sortOrder === "asc" ? (
                                        <>
                                          {" "}
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          {" "}
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}
                              </div>
                            </Row>
                          </th>

                          {/* <th className="w-7">City</th> */}

                          <th
                            onClick={() => sortByJobs("state")}
                            className="w-10"
                          >
                            <Row className="w-[100]">
                              {" "}
                              <div className="col pr-1 t-cursor-pointer">
                                {" "}
                                State{" "}
                              </div>
                              <div className="col">
                                {sortBy == "state" ? (
                                  <>
                                    {" "}
                                    {sortBy === "state" ? (
                                      sortOrder === "asc" ? (
                                        <>
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}
                              </div>{" "}
                            </Row>
                          </th>

                          {/* <th className="w-3">State</th> */}

                          <th
                            onClick={() => sortByJobs("createdOn")}
                            className="w-10"
                          >
                            <Row className="w-[100]">
                              {" "}
                              <div className="col pr-1 t-cursor-pointer">
                                {" "}
                                Age{" "}
                              </div>
                              <div className="col">
                                {sortBy == "createdOn" ? (
                                  <>
                                    {sortBy === "createdOn" ? (
                                      sortOrder === "asc" ? (
                                        <>
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}{" "}
                              </div>
                            </Row>
                          </th>

                          <th
                            onClick={() => sortByJobs("taName")}
                            className="w-15"
                          >
                            <Row className="w-[100]">
                              {" "}
                              <div className="col pr-1 t-cursor-pointer">
                                {" "}
                                TA{" "}
                              </div>
                              <div className="col">
                                {sortBy == "taName" ? (
                                  <>
                                    {" "}
                                    {sortBy === "taName" ? (
                                      sortOrder === "asc" ? (
                                        <>
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}
                              </div>{" "}
                            </Row>
                          </th>
                          <th
                            // onClick={() => sortByJobs("taName")}
                            className="w-20"
                          >
                            Posted On
                          </th>
                          <th
                            className="w-10 "
                            onClick={() => candidateCount()}
                          >
                            {/* <Row className="w-[100]">
                              {' '}
                              <div className="col pr-1 t-cursor-pointer">
                               <i className='simple-icon-user-follow arrow-icon-color'/>
                              </div>
                              <div className="col">
                                {sortBy == 'totalApplied' ? (
                                  <>
                                    {' '}
                                    {sortBy === 'totalApplied' ? (
                                      sortOrder === 'asc' ? (
                                        <>
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </>
                                      ) : (
                                        <>
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {' '}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </>
                                      )
                                    ) : (
                                      <></>
                                    )}
                                    
                                  </>
                                ) : (
                                  <>
                                    {' '}
                                    <Row>
                                      <SvgUpArrow />
                                    </Row>
                                    <Row>
                                      <SvgDownArrow />
                                    </Row>
                                  </>
                                )}
                                  
                                
                              </div>{' '}
                              
                            </Row> */}

                            <Row className="w-[100]">
                              {" "}
                              {sortBy !== "totalApplied" &&
                                sortBy !== "totalCandidates" && (
                                  <>
                                    {" "}
                                    <div className="col pr-1 t-cursor-pointer">
                                      <AiOutlineUserAdd
                                        className="t-user"
                                        title="Awaiting Candidates"
                                      />
                                    </div>
                                    <div className="col">
                                      <Row>
                                        <SvgUpArrow />
                                      </Row>
                                      <Row>
                                        <SvgDownArrow />
                                      </Row>
                                    </div>
                                  </>
                                )}
                              {sortBy == "totalApplied" ? (
                                <>
                                  {" "}
                                  {sortBy === "totalApplied" ? (
                                    sortOrder === "asc" ? (
                                      <>
                                        <div className="col pr-1 t-cursor-pointer">
                                          <AiOutlineUserAdd
                                            className="t-user"
                                            title="Awaiting Candidates"
                                          />
                                        </div>
                                        <div className="col">
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="col pr-1 t-cursor-pointer">
                                          <AiOutlineUserAdd
                                            className="t-user"
                                            title="Awaiting Candidates"
                                          />
                                        </div>
                                        <div className="col">
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </div>
                                      </>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  {" "}
                                  {sortBy === "totalCandidates" ? (
                                    sortOrder === "asc" ? (
                                      <>
                                        <div className="col pr-1 t-cursor-pointer">
                                          <AiOutlineUsergroupAdd
                                            className="t-user"
                                            title="Total Candidates"
                                          />
                                        </div>
                                        <div className="col">
                                          <Row>
                                            <SvgSelectedUpArrow />
                                          </Row>
                                          <Row>
                                            <SvgDownArrow />
                                          </Row>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="col pr-1 t-cursor-pointer">
                                          <AiOutlineUsergroupAdd
                                            className="t-user"
                                            title="Total Candidates"
                                          />
                                        </div>
                                        <div className="col">
                                          <Row>
                                            <SvgUpArrow />
                                          </Row>
                                          <Row>
                                            {" "}
                                            <SvgSelectedDownArrow />
                                          </Row>
                                        </div>
                                      </>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </>
                              )}
                            </Row>
                          </th>

                          <th className="w-5">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {jobs.length > 0 ? (
                          jobs.map((job, index) => {
                            var jobDays = 0;
                            if (job.days === 0) {
                              jobDays = "Today";
                            } else {
                              jobDays = job.days;
                            }
                            return (                              
                                <tr key={index}>
                                  <td className="w-[30]">
                                    {getSerialNumber(index)}
                                  </td>

                                  <td className="w-[120]">
                                    {" "}
                                    <Link
                                      className="text-dark"
                                      to={`/addrequest/${job.id}?t=basicinfo`}
                                      title="Edit Job req"
                                      onClick={() => {
                                        window.localStorage.setItem(
                                          "requestId",
                                          job.id
                                        );
                                        window.localStorage.setItem(
                                          "edit",
                                          "edit"
                                        );
                                        window.localStorage.setItem("add", "");
                                        window.localStorage.setItem(
                                          "currentStatus",
                                          job.jobStatus.key
                                        );
                                        window.localStorage.setItem(
                                          "candidates",
                                          ""
                                        );
                                        window.localStorage.setItem(
                                          "hmsid",
                                          job.hmsId
                                        );
                                      }}
                                    >
                                      <u>{job.jobId}</u>
                                    </Link>{" "}
                                  </td>

                                  <td className="w-[180]">
                                    {" "}
                                    {title === true ? (
                                      <>{job.publicTitle}</>
                                    ) : (
                                      <>{job.jobTitle}</>
                                    )}
                                  </td>
                                  <td className="w-[120]">
                                    {job.jobStatus.value}
                                  </td>
                                  <td className="w-[120]">
                                    <div
                                      className=""
                                      title={job.account.name}
                                      style={{ textOverflow: "clip" }}
                                    >
                                      {job.account.name.length > 10
                                        ? job.account.name.substring(0, 10) +
                                          "..."
                                        : job.account.name}
                                    </div>
                                    {/* {job.account.name} */}
                                  </td>

                                  <td className="w-[120]">
                                    {" "}
                                    {job.remoteLocation ? (
                                      <div title="Remote"> {"Remote"}</div>
                                    ) : (
                                      <>
                                        {!isNullOrEmpty(job.location) ? (
                                          <>{showCity(job.location.address)}</>
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    )}
                                  </td>

                                  <td className="w-[120]">
                                    {job.remoteLocation ? (
                                      <div title="Remote"> {"Remote"}</div>
                                    ) : (
                                      <>
                                        {!isNullOrEmpty(job.location) ? (
                                          <>{showState(job.location.address)}</>
                                        ) : (
                                          <></>
                                        )}
                                      </>
                                    )}
                                  </td>

                                  <td
                                    className="w-[60]"
                                    style={{
                                      color:
                                        job.days >= 30 && job.days < 60
                                          ? "orange"
                                          : job.days >= 60
                                          ? "red"
                                          : "",
                                    }}
                                  >
                                    {jobDays}
                                  </td>

                                  <td
                                    className="w-[120]"
                                    title={displayingTANames(job.talentAdvisor)}
                                  >
                                    {job.talentAdvisor.firstName}
                                  </td>
                                  <td className="w-[80] mb-2">
                                    <div style={{ display: "flex" }}>
                                      {job.jobBoardPosts.length > 0 &&
                                        job.jobBoardPosts
                                          .slice(0, 3)
                                          .map((jobBoardPost, index) => {
                                            return (
                                              <a
                                                href={jobBoardPost.postUrl}
                                                target="_blank"
                                                key={index}
                                              >
                                                {isNullOrEmpty(
                                                  jobBoardPost.logo
                                                ) ? (
                                                  <>
                                                    <img
                                                      src={defaultpostingimg}
                                                      className="t-account-logo ml-1"
                                                      alt="Job Board Post"
                                                      // key={index}
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    <img
                                                      src={jobBoardPost.logo}
                                                      className="t-account-logo ml-1"
                                                      alt="Job Board Post"
                                                      // key={index}
                                                    />
                                                  </>
                                                )}
                                              </a>
                                            );
                                          })}
                                    </div>
                                    <div style={{ display: "flex" }}>
                                      {job.jobBoardPosts.length > 3 &&
                                        job.jobBoardPosts
                                          .slice(3, 5)
                                          .map((jobBoardPost, index) => {
                                            return (
                                              <a
                                                href={jobBoardPost.postUrl}
                                                target="_blank"
                                                // id={`jobboardpost-${index}`}
                                                key={index}
                                              >
                                                {isNullOrEmpty(
                                                  jobBoardPost.logo
                                                ) ? (
                                                  <>
                                                    <img
                                                      src={defaultpostingimg}
                                                      className="t-account-logo ml-1"
                                                      alt="Job Board Post"
                                                      // key={index}
                                                    />
                                                  </>
                                                ) : (
                                                  <>
                                                    <img
                                                      src={jobBoardPost.logo}
                                                      className="t-account-logo ml-1"
                                                      alt="Job Board Post"
                                                      // key={index}
                                                    />
                                                  </>
                                                )}
                                              </a>
                                            );
                                          })}
                                      {job.jobBoardPosts.length > 5 ? (
                                        <>
                                          <Link
                                            to={`/addrequest/${job.id}?t=basicinfo#jobBoardPost`}
                                          >
                                            <span
                                              className="font-bold text-primary-blue text-lg"
                                              onClick={() => {
                                                window.localStorage.setItem(
                                                  "requestId",
                                                  job.id
                                                );
                                              }}
                                            >
                                              <span className="ml-1">...</span>
                                            </span>
                                          </Link>
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </td>
                                  <td className="w-[60] ">
                                    <div
                                      className="list-item p-0"
                                      onClick={() => toggle(job.id)}
                                      onMouseEnter={() =>
                                        handleMouseEnter(job.id)
                                      }
                                      onMouseLeave={handleMouseLeave}
                                    >
                                      {showHMSIcon(job.jobStatus.key, index) ? (
                                        <>
                                          <Link
                                            to={`/addrequest/${job.id}?t=candidates`}
                                            onClick={() => {
                                              window.localStorage.setItem(
                                                "requestId",
                                                job.id
                                              );
                                              window.localStorage.setItem(
                                                "currentStatus",
                                                job.jobStatus.key
                                              );
                                              window.localStorage.setItem(
                                                "candidates",
                                                "candidates"
                                              );
                                              window.localStorage.setItem(
                                                "hmsid",
                                                job.hmsId
                                              );
                                              window.localStorage.setItem(
                                                "add",
                                                ""
                                              );
                                            }}
                                            title="View candidates"
                                          >
                                            <div className="text-dark">
                                              {
                                                job.appliedStatusCandidates
                                                  .totalApplied
                                              }
                                              <hr className=" t-hr-wid" />
                                              {
                                                job.appliedStatusCandidates
                                                  .totalCandidates
                                              }
                                            </div>
                                          </Link>
                                        </>
                                      ) : (
                                        <>
                                          {appliedJobCandidatesCount(
                                            job.appliedStatusCandidates
                                              .totalApplied
                                          )}
                                          <hr className="t-hr-wid" />
                                          {appliedJobCandidatesTotalCount(
                                            job.appliedStatusCandidates
                                              .totalCandidates
                                          )}
                                        </>
                                      )}
                                    </div>
                                    {showTooltip && jobId === job.id && (
                                      <div className="">
                                        <div className="t-tooltip ">
                                          <div className="p-3 ">
                                            <div className="flex ">
                                              <Col sm={2} className="vertical">
                                                <Row className="justify-content-center ">
                                                  Job Offer
                                                </Row>
                                                <Row className="flex  justify-content-center">
                                                  {job.appliedStatusCandidates
                                                    .totalJobOfferAccepted +
                                                    job.appliedStatusCandidates
                                                      .totalSelectedForHire}
                                                </Row>
                                              </Col>
                                              <Col sm={2} className="vertical ">
                                                <Row className="justify-content-center">
                                                  Interview
                                                </Row>
                                                <Row className="flex justify-content-center">
                                                  {job.appliedStatusCandidates
                                                    .totaInterviewScheduled +
                                                    job.appliedStatusCandidates
                                                      .totalInterviewRequested +
                                                    job.appliedStatusCandidates
                                                      .totalInterviewCompleted}
                                                </Row>
                                              </Col>
                                              <Col sm={2} className="vertical">
                                                <Row className="justify-content-center">
                                                  Shortlisted
                                                </Row>
                                                <Row className="flex justify-content-center">
                                                  {
                                                    job.appliedStatusCandidates
                                                      .totalShortlisted
                                                  }
                                                </Row>
                                              </Col>
                                              <Col sm={2} className="vertical ">
                                                <Row className="justify-content-center">
                                                  Considering
                                                </Row>
                                                <Row className="flex justify-content-center">
                                                  {
                                                    job.appliedStatusCandidates
                                                      .totalConsidering
                                                  }
                                                </Row>
                                              </Col>
                                              <Col sm={2} className="vertical">
                                                <Row className="justify-content-center">
                                                  Rejected
                                                </Row>
                                                <Row className="flex justify-content-center">
                                                  {
                                                    job.appliedStatusCandidates
                                                      .totalRejected
                                                  }
                                                </Row>
                                              </Col>
                                              <Col sm={2}>
                                                <Row className="justify-content-center">
                                                  Declined
                                                </Row>
                                                <Row className="flex justify-content-center">
                                                  {
                                                    job.appliedStatusCandidates
                                                      .totalDeclined
                                                  }
                                                </Row>
                                              </Col>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </td>

                                  <td className="w-[30]">
                                    <div className="actionbutton">
                                      <Row>
                                        <div className="col-5">
                                          {isNavigateHms(job.jobStatus.key) ? (
                                            <>
                                              {displayHmsIcon(
                                                job.jobStatus.key,
                                                job.appliedStatusCandidates,
                                                job.statusUpdatedOn,
                                                job.hmsId
                                              )}
                                            </>
                                          ) : (
                                            <>
                                              <div
                                                title="HMS Link"
                                                data-toggle="modal"
                                                data-target="#exampleModal"
                                              >
                                                {" "}
                                                {displayHmsIcon(
                                                  job.jobStatus.key,
                                                  job.appliedStatusCandidates,
                                                  job.statusUpdatedOn,
                                                  job.hmsId
                                                )}
                                              </div>
                                            </>
                                          )}
                                        </div>
                                        <div className="col flex center">
                                          {" "}
                                          <>
                                            <span title="Landing Page Link">
                                              {displayLpUrl(
                                                job.id,
                                                job.landingPageTemplate,
                                                job.landingPageFields
                                              )}                                             
                                            </span>
                                          </>
                                        </div>
                                      </Row>
                                    </div>
                                  </td>
                                </tr>                            
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </Table>
                  </div>
                </div>

                <>
                  {jobs === 0 ? (
                    <>
                      {" "}
                      <h4
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        No job requisitions available
                      </h4>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              </div>
            </CardBody>
            <CardFooter>
              <Row className="wrapper">
                <h3 className="ml-3 matrecords">
                  {" "}
                  Total matching records : {size}
                </h3>

                <Pagination
                  currentPage={currentPage}
                  totalPage={totalPage}
                  numberLimit={5}
                  firstIsActive={true}
                  onChangePage={(e) => onChangePage(e)}
                />
              </Row>
            </CardFooter>
          </Card>
        </div>
      </div>
    </>
  );
};

export default Requests;
